import Box from '@mui/material/Box';
import ButtonComponent from './ButtonComponent';
import MediumTypography from './MediumTypography';
import {
  Breakpoint,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Slide,
  SxProps,
  Theme,
} from '@mui/material';
import { ReactComponent as WarningIcon } from '../../assets/images/WarningIcon.svg';
import { TransitionProps } from '@mui/material/transitions';
import React, { useEffect } from 'react';

interface ModalProps {
  open: boolean;
  maxWidth?: Breakpoint;
  onClose?: () => void;
  labelId1?: string;
  description: string | string[]; // can now be string or array of strings
  defaultDescription?: string;
  positiveActionLabel?: string;
  labelId2?: string;
  negativeActionLabel?: string;
  onOk?: () => void;
  onCancel?: () => void;
  hidePositiveBtn?: boolean;
  sxProps?: SxProps<Theme>;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<ModalProps>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalPopup(props: Readonly<ModalProps>) {
  const {
    open,
    onClose,
    onOk,
    onCancel,
    description,
    defaultDescription,
    labelId1,
    labelId2,
    positiveActionLabel,
    negativeActionLabel,
    maxWidth,
    hidePositiveBtn,
    sxProps,
  } = props;

  useEffect(() => {
    try {
      const customEvent = new CustomEvent('openModel', {
        detail: {
          message: 'This is a custom event for openModel',
          time: new Date(),
        },
      });
      document.dispatchEvent(customEvent);
    } catch (ex) {
      console.log('openModel CustomEvent', ex);
    }
  }, [open]);

  const renderDescription = () => {
    if (Array.isArray(description)) {
      return (
        <ul style={{ margin: 0, paddingLeft: '20px' }}>
          {description.map((item) => (
            <li key={`${item}-description`}>
              <MediumTypography
                labelid={typeof item === 'string' ? item : ''}
                defaultlabel={
                  defaultDescription ?? 'Are you sure you want reset?'
                }
                fontweight={500}
                textColor="#2a4241"
                sxProps={{ lineHeight: 1.5 }}
              />
            </li>
          ))}
        </ul>
      );
    }
    return (
      <MediumTypography
        labelid={typeof description === 'string' ? description : ''}
        defaultlabel={defaultDescription ?? 'Are you sure you want reset?'}
        fontweight={500}
        textColor="#2a4241"
        sxProps={{ lineHeight: 1.5 }}
      />
    );
  };

  return (
    <Box>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        fullWidth
        maxWidth={maxWidth ?? 'xs'}
        aria-describedby="alert-dialog-slide-description"
        sx={sxProps}
      >
        <DialogContent sx={{ p: 0 }} className="p-lg">
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container rowSpacing={'24px'} columnSpacing={'4px'}>
              <Grid
                item
                xs={1.5}
                pl={0}
                display={'flex'}
                justifyContent={'left'}
              >
                <WarningIcon />
              </Grid>
              <Grid item xs={10.5} className="mt-xs">
                <MediumTypography
                  labelid={'warning'}
                  defaultlabel={'Warning!'}
                  fontweight={700}
                  fontSize="24px"
                  textColor="#2a4241"
                  className="pb-md"
                />

                {/* auto handles string vs array */}
                {renderDescription()}
              </Grid>
            </Grid>
          </DialogContentText>
          <DialogActions className="pt-sm" sx={{ p: 0 }}>
            <Box>
              {onCancel && (
                <ButtonComponent
                  className="btn-primary btn-cancel alrt_Width_btn"
                  variantType="contained"
                  labelId={labelId1}
                  defaultLabelId={negativeActionLabel}
                  onClick={onCancel}
                />
              )}
              {!hidePositiveBtn && (
                <ButtonComponent
                  variantType="contained"
                  type="submit"
                  className="btn-primary btn-submit alrt_Width_btn ml-md"
                  labelId={labelId2}
                  defaultLabelId={positiveActionLabel}
                  onClick={onOk}
                />
              )}
            </Box>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
